export default __webpack_public_path__ + "static/media/back-glass.0b7db3bd.png";